// Generated by CoffeeScript 2.7.0
export var TabItem = Vue.extend({
  props: {
    name: String,
    tabKey: [String, Number]
  },
  data: function() {
    return {
      active: false
    };
  },
  template: `<div class="tab-content-item" v-show='active'>
  <slot></slot>
</div>`
});

export var Tabs = Vue.extend({
  props: {
    customClass: [String, Object, Array],
    navsClass: [String, Object, Array]
  },
  data: function() {
    return {
      tabs: [],
      activeTab: null
    };
  },
  template: `<div class="tabs" :class='customClass'>
  <div class="tab-navs" :class='navsClass'>
    <div class="nav-item"
         v-for='tab in tabs'
         :class='{ active: tab.active }'
         :key='tab.tabKey'
         @click='selectTab(tab)'>
      <span>{{ tab.name }}</span>
    </div>
    <slot name='tab-control'></slot>
  </div>
  <div class="tab-contents">
    <slot></slot>
  </div>
</div>`,
  created: function() {
    this.tabs = this.$children;
    return this.activeTab = _.findWhere(this.tabs, {
      active: true
    });
  },
  mounted: function() {
    if (!this.activeTab && this.tabs.length) {
      this.activeTab = _.first(this.tabs);
      return this.activeTab.active = true;
    }
  },
  methods: {
    selectTab: function(tab) {
      if (this.activeTab === tab) {
        return;
      }
      this.activeTab.active = false;
      tab.active = true;
      return this.activeTab = tab;
    }
  }
});
